import { useAct } from 'FlowBuilder/store'
import './FilterDecisionMakerSet.scoped.scss'

export default function FilterDecisionMakerSet() {
  const act = useAct()
  const { name, description, decisionMakers, filterableAttributes } = useSel(s => s.decisionMakersSet)
  const excludedDecisionMakerIds = useSel(s => s.decisionMakersSet.actionExcludedDecisionMakerIds || [])
  const action = useSel(s => s.actions.entities[s.local.selectedActionId])

  const [filterCategory, setFilterCategory] = useState(null)
  const [filterValue, setFilterValue] = useState('')

  const filterOptions = decisionMakers.reduce((acc, dm) => {
    if (!dm.extraData) return acc
    if (!dm.extraData[filterCategory]) return acc
    if (dm.extraData[filterCategory] && !acc.includes(dm.extraData[filterCategory].toString())) {
      acc.push(dm.extraData[filterCategory].toString())
    }
    return acc
  }, [])

  const filteredDecisionMakers = decisionMakers.filter(dm => {
    if (!filterCategory || !filterValue) return true
    if (dm.extraData[filterCategory]) {
      return dm.extraData[filterCategory].toString() == filterValue.toString()
    }
    return false
  })

  const includedDecisionMakerIds = decisionMakers.filter(dm => !excludedDecisionMakerIds.includes(dm.id)).map(dm => dm.id)

  const upsertAction = (newExcludedIds) => {
    const newIncludedIds = decisionMakers.filter(dm => !newExcludedIds.includes(dm.id)).map(dm => dm.id)
    act.actions.upsert(action.id, { 
      excludedDecisionMakerIds: newExcludedIds, 
      includedDecisionMakerIds: newIncludedIds 
    })
  }

  const toggleDecisionMaker = (id) => {
    let excludedIds = [...excludedDecisionMakerIds]
    if (excludedIds.includes(id)) {
      excludedIds = excludedIds.filter(dmId => dmId !== id)
    } else {
      excludedIds.push(id)
    }
    act.decisionMakersSet.setDecisionMakerExcludedIds(excludedIds)
    upsertAction(excludedIds)
  }

  const includeAll = () => {
    const newExcludedIds = excludedDecisionMakerIds.filter(id => !filteredDecisionMakers.some(dm => dm.id === id))
    act.decisionMakersSet.setDecisionMakerExcludedIds(newExcludedIds)
    upsertAction(newExcludedIds)
  }

  const excludeAll = () => {
    const newExcludedIds = excludedDecisionMakerIds.concat(filteredDecisionMakers.map(dm => dm.id))
    act.decisionMakersSet.setDecisionMakerExcludedIds(newExcludedIds)
    upsertAction(newExcludedIds)
  }

  return <div className='decision-maker-set-filter'>
    <div className="dm-set-header">
      <div className='dm-set-info'>
        <span className='dm-set-name'>{name}</span>
        <span className='dm-set-description'>{description}</span>
        <span className='dm-set-total'>{includedDecisionMakerIds.length}/{decisionMakers.length} Recipients Included</span>
      </div>
      <div className='dm-set-controls'>
        {filterableAttributes && Object.keys(filterableAttributes).length > 0 && (
          <div className='dm-set-filters'>
            <select
              value={filterCategory || ''}
              onChange={e => {
                setFilterCategory(e.target.value)
                setFilterValue('')
              }}
            >
              <option value="">Filter by...</option>
              {filterableAttributes && Object.keys(filterableAttributes).map(attr => (
                <option key={attr} value={attr}>{filterableAttributes[attr]}</option>
              ))}
            </select>
            {filterCategory && (
              <select
                value={filterValue}
                onChange={e => setFilterValue(e.target.value)}
              >
                <option value="">Select {filterableAttributes[filterCategory]}</option>
                {filterOptions.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            )}
          </div>
      )}
        <div className='dm-set-buttons'>
          <button className='button secondary margin-top' onClick={includeAll}>Include All {filteredDecisionMakers.length} {filterValue} Recipients</button>
          <button className='button secondary margin-top' onClick={excludeAll}>Exclude All {filteredDecisionMakers.length} {filterValue} Recipients</button>
        </div>
      </div>
    </div>
    <div className="">
      {filteredDecisionMakers && filteredDecisionMakers.length > 0 ? (
        <table className="decision-makers-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Included</th>
            </tr>
          </thead>
          <tbody>
            {filteredDecisionMakers.map(dm => (
              <tr key={dm.id} className={excludedDecisionMakerIds?.includes(dm.id) ? 'excluded' : ''}>
                <td><span>{dm.name}</span></td>
                <td><span>{dm.email}</span></td>
                <td>
                  <input
                    type="checkbox"
                    checked={!(excludedDecisionMakerIds || []).includes(dm.id)}
                    onChange={() => toggleDecisionMaker(dm.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div>No recipients found.</div>
      )}
    </div>
    <div className=''>
      <button className='button primary margin-top' onClick={act.local.closeModal}>
        Close
      </button>
    </div>
  </div>
}
